import { CreatorPublicView } from '@/components/creators/creator-public-view'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/creator/$token')({
  component: CreatorPublicRoute,
})

/**
 * Render the CreatorPublicView component for the current route token.
 *
 * @returns A JSX element that renders `CreatorPublicView` with the route `token` prop.
 */
function CreatorPublicRoute() {
  const { token } = Route.useParams()

  return <CreatorPublicView token={token} />
}
